import axios from '@/axios'
import { getMessageFromError } from '../../utils/functions'

export default {
  getUsers({ commit }, payload) {
    const { limit, page, order, search } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .get('/user', {
          params: {
            limit,
            page,
            order,
            search
          }
        })
        .then(function(response) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          commit('SET_STATE', {
            action: 'users',
            data: response.data.data
          })
          commit('SET_STATE', {
            action: 'total',
            data: response.data.totalCount
          })
          commit('SET_STATE', {
            action: 'FilteredCount',
            data: response.data.FilteredCount
          })
          resolve({
            data: response.data.data,
            FilteredCount: response.data.FilteredCount,
            total: response.data.totalCount
          })
        })
        .catch(function(error) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          reject(error.message)
        })
    })
  },

  insert({ commit }, payload) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .post('/user', payload)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const { message } = getMessageFromError(err)
          reject({
            message
          })
        })
    })
  },

  delete({ commit }, id) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .delete(`/user/${id}`)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            message
          })
        })
    })
  },

  get(_, id) {
    return new Promise(async (resolve, reject) => {
      await axios
        .get(`/user/${id}`)
        .then(res => {
          resolve({
            data: res.data,
            message: res.data.message
          })
        })
        .catch(err => {
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            message
          })
        })
    })
  },

  update({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .put(`/user/${id}`, data)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const { message } = getMessageFromError(err)
          reject({
            message
          })
        })
    })
  },

  updateStatus({ commit }, { id, status }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .put(`/user/${id}/update-status`, {
          status
        })
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            errors: Object.values(err.response.data.meta),
            message
          })
        })
    })
  },

  getAssignedUsers: async ({ commit }, { id }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const req = await axios.get(`/multi-location-user/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'assignedUsers',
        data: req.data.DataList
      })
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },

  getValidUserForAssign: async () => {
    try {
      const req = await axios.get('/multi-location-user/dropdownList')
      return req.data
    } catch (err) {
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },

  assignUser: async ({ commit }, payload) => {
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })
      const req = await axios.post('/multi-location-user', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return req.data
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },

  removeAssignedUser: async ({ commit }, id) => {
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })
      const req = await axios.delete(`/multi-location-user/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return req
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },
  // get user's bookmarked navs
  getBookmarkedNavs: async ({ commit }, status = false) => {
    try {
      const req = await axios.get('/bookmark')
      // set selected bookmarks
      localStorage.setItem('selectedBookMarks', JSON.stringify(req.data.usersBookMarks.map(x => x.bookMark)))
      if (status) {
        commit('UPDATE_BOOKMARK_MENU', null, { root: true })
      }
      return req.data.usersBookMarks
    } catch (err) {
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },

  // update book mark
  addORupdateBookMark(_, payload) {
    return new Promise(async (resolve, reject) => {
      await axios
        .post('/bookmark', { ...payload, status: payload.val })
        .then(res => {
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          const { message } = getMessageFromError(err)
          reject({
            message
          })
        })
    })
  },

  updateMigrateMetrcStatus({ commit }, user) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .post('/dashboard/migrate-to-metrc', { userId: user.id, licenseNumber: user.omma_license_number, metrcApiKey: user.metrcKey })
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
          console.log(res.data)
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const { message } = getMessageFromError(err)
          reject({
            message
          })
        })
    })
  },

  async downloadInvalidData({ commit }, user) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post('/dashboard/invalid-items', {
        userId: user.id,
        licenseNumber: user.omma_license_number || 'ABCD',
        metrcApiKey: user.metrcKey || 'XYZ'
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      console.log(res.data.invalidItems, 'Invalid Items')

      return {
        data: res.data.invalidItems,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)

      return message
    }

    // return new Promise(async (resolve, reject) => {
    // await axios
    //   .post('/dashboard/invalid-items', { userId: user.id, licenseNumber: user.omma_license_number || "ABCD", metrcApiKey: user.metrcKey || "XYZ" })
    //   .then(res => {
    //     resolve({
    //       data: res.data.data.invalidItems,
    //       message: res.data.message
    //     })
    //     // console.log(res)
    //   })
    //   .catch(err => {
    //     commit('SET_STATE', {
    //       action: 'loading',
    //       data: false
    //     })
    //     const { message } = getMessageFromError(err)
    //     reject({
    //       message
    //     })
    //   })
    // })
    // commit('SET_STATE', {
    //   action: 'loading',
    //   data: false
    // })
  }
}
